import React from 'react'
import { IBulkAction } from '../../../Component/Common/Components/DataTable/BulkAction';
import { DataTable } from '../../../Component/Common/Components/DataTable/DataTable';
import { IFilter } from '../../../Component/Common/Components/DataTable/Filters';
import { ColumnSortOption } from '../../../Component/Model/Dto/ColumnSortOption';
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import { EmployeeStructureTable } from './EmployeeStructureColumns';


interface IEmployeeStructureDataTable {
    employeeStructureData: EmployeeStructureTable;
    entriesPerPage: EntriesPerPage;
    pageNumber: number;
    filteredItemsCount: number;
    totalItemsCount: number;
    entriesPerPageChanged: (entriesPerPage: number) => void;
    pageNumberChanged: (pageNumber: number) => void;
    searchValueChanged: (searchValue: string) => void;
    columnSortingChanged: (sortOption: ColumnSortOption) => void;
    isLoading: boolean;
    hasFilters: boolean;
    employeeStructureFilters: IFilter[];
    filtersChanged: (filterProps: any) => void;
    bulkActions: IBulkAction[];
}

export const EmployeeStructureDataTable = (props: IEmployeeStructureDataTable) => {
    return (
        <>
            {props.hasFilters ?
                <DataTable
                    key={props.totalItemsCount}
                    bulkActions={props.bulkActions}
                    table={props.employeeStructureData}
                    entriesPerPage={props.entriesPerPage}
                    pageNumber={props.pageNumber}
                    filteredItemsCount={props.filteredItemsCount}
                    totalItemsCount={props.totalItemsCount}
                    entriesPerPageChanged={props.entriesPerPageChanged}
                    pageNumberChanged={props.pageNumberChanged}
                    isLoading={props.isLoading}
                    canSearch
                    searchValueChanged={props.searchValueChanged}
                    filters={props.employeeStructureFilters}
                    filtersChanged={props.filtersChanged}
                    manualSorting={true}
                    columnSortingChanged={props.columnSortingChanged}
                ></DataTable>
                :
                <DataTable
                    key={props.totalItemsCount}
                    bulkActions={props.bulkActions}
                    table={props.employeeStructureData}
                    entriesPerPage={props.entriesPerPage}
                    pageNumber={props.pageNumber}
                    filteredItemsCount={props.filteredItemsCount}
                    totalItemsCount={props.totalItemsCount}
                    entriesPerPageChanged={props.entriesPerPageChanged}
                    pageNumberChanged={props.pageNumberChanged}
                    isLoading={props.isLoading}
                    canSearch
                    searchValueChanged={props.searchValueChanged}
                    manualSorting={true}
                    columnSortingChanged={props.columnSortingChanged}
                ></DataTable>
            }
        </>
    )
}

